/**
 * Presentation Layer - Custom Components Barrel Export
 * Hand-written components (not from shadcn)
 */

// Navigation & Layout
export { default as Navbar } from "./navbar";

// UI Utilities
export * from "./language-switcher";
export * from "./network-status-indicator";
export * from "./theme-switcher";
export * from "./spinner";

// Feedback Components
export * from "./loading-with-logo";
export * from "./error-display";

// Form Components
export * from "./form-input";
export * from "./step-progress";
export * from "./oauth-button";

// Modal Components
export * from "./modal";

// Animated Components
export * from "../animated";
